



































import Vue from "vue";
import { User } from '../../../serverless/functions/src/models/user';
import { Player } from '../gameplay/Player';

export default Vue.extend({
  name: "statistics",
  components: {},
  props: {
    player: Player,
  },
  data: () => ({
  }),
  methods: {
  }
});
